module.exports = __webpack_public_path__ + "img/IMG-20200716-WA0034.b8ca01bf.jpg";